export default {
  'collector.restAddress': {
    ko: 'REST IP/Port',
    ja: 'REST IP/ポート',
    en: 'REST IP/Port',
    cn: '',
  },
  'collector.terminalAddress': {
    ko: '터미널 IP',
    ja: 'ターミナルIP',
    en: 'Teminal IP',
    cn: '',
  },
  'collector.title.add': {
    ko: '수집기 추가',
    ja: 'コレクターを追加',
    en: 'Add Collector',
    cn: '',
  },
  'collector.handleCollect': {
    ko: '수집 시작/중지',
    ja: '収集を開始/停止',
    en: 'Start/stop collection',
    cn: '',
  },
  'collector.title.edit': {
    ko: '수집기 수정',
    ja: 'コレクターを修正',
    en: 'Edit Collector',
    cn: '',
  },
  'collector.stackType': {
    ko: 'Stack 유형',
    ja: 'スタックのタイプ',
    en: 'Stack type',
    cn: '',
  },
  'collector.handleCollector': {
    ko: '수집기 시작/중지',
    ja: 'コレクターを開始/停止',
    en: 'Start/stop collector',
    cn: '',
  },
};
